import React, { useState, useEffect } from "react";
import "./LandingPageLeft.css";
import { motion, AnimatePresence } from "framer-motion";
import { HashLink as Link } from "react-router-hash-link";
const words = ["AMALGAMATE!", "VOTE", "UNITE"];

function LandingPageLeft() {
  const [index, setIndex] = useState(0);
  const [readMore, setReadMore] = useState(false);

  const handleReadMoreClick = () => {
    if (!readMore) {
      setReadMore(true);
    } else {
      setReadMore(false);
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // Change every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="landingPageLeft">
      <div className="billionUserContainer">
        <div className="billionUserContainer2">
          <div className="userImgContainer">
            <img
              src="/Assets/Donation/LandingPage/billionUser1.svg"
              alt="no img found"
              className="userImg2"
            />
            <img
              src="/Assets/Donation/LandingPage/billionUser2.svg"
              alt="no img found"
              className="userImg"
            />
            <img
              src="/Assets/Donation/LandingPage/billionUser3.svg"
              alt="no img found"
              className="userImg"
            />
          </div>
          <div>
            <span className="billionUserText">Built for 10+ Billion users</span>
          </div>
        </div>
      </div>
      <div className="itsTimeToContainer">
        <span className="itsTimeToText">IT'S TIME TO </span>

        <div className="unite">
          <AnimatePresence mode="wait">
            <motion.span
              key={words[index]}
              initial={{ y: "100%", opacity: 0 }}
              animate={{ y: "0%", opacity: 1 }}
              exit={{ y: "-100%", opacity: 0 }}
              transition={{ duration: 0.8 }}
              className="uniteMotion"
            >
              {words[index]}
            </motion.span>
          </AnimatePresence>
        </div>
      </div>
      <div className="longTextContainer">
        <div className="longText">
          Our mission is to create and provide humanity with a tool that allows
          us to collectively optimize our remaining existence. The platform will
          empower communities to decide what is best for themselves and to
          create the change they want through democratically selected
          initiatives. The{" "}
          <img
            src="/Assets/Donation/LandingPage/amalgamate.svg"
            alt="no img found"
            className="amalgamateWord"
          />
          <span className="longText">
            {" "}
            platform will promote true democracy through voting, scientific
            processes, expert led group planning, society led strategizing, and
            hive mind collaboration.
          </span>
        </div>
      </div>
      <div className="donationLastContainer">
        <Link to="#donationPage" smooth>
          <div className="donateNowContainer">
            <span className="donateNowText">Donate Now</span>
          </div>
        </Link>
        <div className="donationAppAvailableFor">
          <span className="appAvailableForText">App Available For</span>
          <div className="iconContainer">
            <div className="iconContainer2">
              <img
                src="/Assets/Donation/LandingPage/playstoreIcon.png"
                className="smallIcon"
                alt="no img found"
                onClick={() => window.open("https://play.google.com/store/apps/details?id=com.amalgamate", "_blank")} style = {{ cursor: "pointer" }}
              />
              <div className="verticalLine"></div>
              <img
                src="/Assets/Donation/LandingPage/androidIcon.png"
                className="smallIcon"
                alt="no img found"
                onClick={() => window.open("https://apps.apple.com/in/app/amalgamate/id6744918457", "_blank")} style = {{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPageLeft;
